import { connect } from 'react-redux';
import AnchorErrorTracking from '../../modules/AnchorErrorTracking';
import { trackEvent } from '../../modules/analytics';
import { clickAccount, requestToLogOutUser } from '../../user';
import {
  fetchMyPodcastStatus,
  fetchMyPodcastImportStatus,
} from '../../podcast';
import { stopAllAudio } from '../../clipSelection';
import {
  endEpisodeAudio,
  setIsPlaying,
} from '../../screens/EpisodeEditorScreen/duck';
import {
  fetchGeoRegion,
  setIsCookieBannerDismissed,
  UNKNOWN_GEO_REGION,
} from '../../compliance';
import { duckOperations as globalPodcastDuckOperations } from '../../store/global/podcast';
import App from '../App';

const ROUTE_TRANSITION = 'ROUTE_TRANSITION';

const mapStateToProps = (
  {
    clipper,
    compliance,
    money: {
      status: { isAllowedToAuthenticateStripe },
    },
    user: {
      user,
      isAccountMenuOpen,
      stationId,
      hasArchivedWaves,
      hostName,
      menuMode,
      permissions,
      shareLinkPath,
      podcastNetwork,
    },
    pageMetadata,
    podcast,
    global: {
      podcast: {
        podcast: {
          campaigns,
          profile: {
            podcastMetadata: { podcastName },
          },
          metadata: { podcastImage },
        },
      },
    },
  },
  routerProps
) => {
  const isEuropeanGeoRegion =
    compliance.geoRegion &&
    (compliance.geoRegion === 'EU' ||
      compliance.geoRegion === UNKNOWN_GEO_REGION);
  const isLoggedIn = !!user;
  if (isLoggedIn) {
    // side effect
    AnchorErrorTracking.identifyUser({ userId: user.userId });
  }
  return {
    clipper,
    compliance,
    campaign: pageMetadata.campaign,
    hasArchivedWaves,
    isAccountMenuOpen,
    isAllowedToSeeMoneyNavItem: isAllowedToAuthenticateStripe,
    isEuropeanGeoRegion,
    location: routerProps.location,
    menuMode,
    permissions,
    podcast,
    stationId,
    user,
    shareLinkPath,
    podcastNetwork,
    hostName,
    campaigns,
    isLoggedIn,
    podcastName,
    podcastImage,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    clickAccount: target => dispatch(clickAccount(target)),
    requestToLogOutUser: () => dispatch(requestToLogOutUser()),
    fetchMyPodcastImportStatus: () => dispatch(fetchMyPodcastImportStatus()),
    fetchMyPodcastStatus: () => dispatch(fetchMyPodcastStatus()),
    fetchGeoRegion: () => dispatch(fetchGeoRegion()),
    dispatchPageTransitionAction: location =>
      dispatch(pageTransitionAction(location)),
    pushLocation: location => dispatch(push(location)),
    stopAllAudio: () => {
      dispatch(stopAllAudio());
    },
    stopEditorAudio: () => {
      dispatch(endEpisodeAudio());
      dispatch(setIsPlaying(false));
    },
    fetchPodcastAndSet: () => {
      dispatch(globalPodcastDuckOperations.fetchPodcastAndSet());
    },
  },
  onDismissCookieBanner: () => dispatch(setIsCookieBannerDismissed(true)),
  onClickNavItem: (name, attributes) => {
    trackEvent(name, attributes, { providers: [mParticle] });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

/**
 * Page transition in the redux-analytics format
 * (see middleware.js)
 */
function pageTransitionAction(location) {
  return {
    type: ROUTE_TRANSITION,
    meta: {
      analytics: {
        type: 'route-transition',
        payload: location,
      },
    },
  };
}
